import React from 'react';
import { CssBaseline, Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
// import { useLocation, useHistory } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { tokensState } from '../../features/auth';
import { TokensDto } from '@oh-auth/dto/lib';
import { userQuery } from '../../features/user';
import Alert from '@material-ui/lab/Alert';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100vw',
		height: '100vh',
		background: theme.palette.grey[100],
	},
	toolbar: {
		flexDirection: 'row',
	},
	title: {
		flexGrow: 1,
	},
}));

interface DashboardProps {
	children: any;
}

export function Dashboard(props: DashboardProps) {
	const { children } = props;
	const classes = useStyles();
	// const { pathname } = useLocation();
	// const history = useHistory();

	const { sub } = useRecoilValue(tokensState) as TokensDto;
	const currentUser = useRecoilValue(userQuery(sub));

	const { t } = useTranslation();

	// const tab = pathname.split('/')[2] || 'user';

	// const handleTabChange = useCallback(
	// 	(e, value) => {
	// 		history.push(`/dashboard/${value}`);
	// 	},
	// 	[history]
	// );

	return (
		<div className={classes.root}>
			{currentUser.username === 'admin' ? (
				<></>
			) : (
				<Container maxWidth="lg">
					<Alert severity="info">{t('dashboard.notAdmin')}</Alert>
				</Container>
			)}
			<CssBaseline />
			{/* <AppBar position="fixed">
				<Container maxWidth="lg">
					<Toolbar className={classes.toolbar}>
						<Typography className={classes.title} variant="h6">
							Auth Dashboard
						</Typography>
						<Tabs
							value={tab}
							onChange={handleTabChange}
							aria-label="simple tabs example"
						>
							<Tab
								value="user"
								label={t('dashboard.userTab')}
								id="navigation-user"
								aria-controls="simple-tabpanel-0"
							/>
							<Tab
								value="app"
								label={t('dashboard.appTab')}
								id="navigation-app"
								aria-controls="simple-tabpanel-1"
							/>
						</Tabs>
					</Toolbar>
				</Container>
			</AppBar> */}
			{/* <Toolbar /> */}
			<Container maxWidth="lg">{children}</Container>
		</div>
	);
}
